import { render, staticRenderFns } from "./answerdetail.vue?vue&type=template&id=7ac00b84&scoped=true"
import script from "./answerdetail.vue?vue&type=script&lang=js"
export * from "./answerdetail.vue?vue&type=script&lang=js"
import style0 from "./answerdetail.vue?vue&type=style&index=0&id=7ac00b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac00b84",
  null
  
)

export default component.exports